import { debug, extractRequestMetadata, makeCookieSessionStorage, makeSrvLgApiConnector, } from "@lg-plus/landing-modules";
export async function pollHandler(req, res) {
    if (req.method !== "GET") {
        res.status(405).end(); // Method Not Allowed
        return;
    }
    const pollingRequestId = req.query.id;
    debug("Polling request for ID:", pollingRequestId);
    if (!pollingRequestId || typeof pollingRequestId !== "string") {
        res.status(400).end();
        return;
    }
    const sessionStorage = makeCookieSessionStorage(req, res);
    const connector = makeSrvLgApiConnector();
    const apiCallResult = await connector.triggerPoll(pollingRequestId, {
        sessionToken: sessionStorage.load() || "",
        request: extractRequestMetadata(req),
    });
    if (apiCallResult.sessionToken) {
        sessionStorage.store(apiCallResult.sessionToken);
    }
    res.status(200).json(apiCallResult);
    debug("API response:", apiCallResult);
}
